import React from "react";
import AdnCard from "../common/adnCard/AdnCard";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import { Row, Col, Modal, Form, List } from "antd";
import AdnList from "../common/adnList/AdnList";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import { EditOutlined } from "@ant-design/icons";
import AdnInput from "../common/adnInput/AdnInput";
import { AdnValidationQuestion } from "./ValidationsTemplate";
import { useTranslation } from "react-i18next";

function TemplateListForm({
  placeholder,
  options,
  handleChange,
  questions,
  handleUpdate,
  visible,
  setVisible,
  setCurrentQuestion,
  currentQuestion,
  loading,
  submitLoading,
}) {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  return (
    <>
      <AdnPageTitle title={t("template.title")} />
      <AdnCard loading={loading}>
        <Row>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 12 }}
            xl={{ span: 8 }}
            xxl={{ span: 8 }}
          >
            <AdnDropdown
              placeholder={placeholder}
              options={options}
              handleChange={handleChange}
            />
          </Col>
        </Row>
        <br />

        <Row>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 20 }}
            xxl={{ span: 16 }}
          >
            {questions !== "undefined" && questions.length === 0 ? null : (
              <AdnList
                style={{ float: "right" }}
                data={questions}
                header={<b>{t("template.labels.questions")}</b>}
                renderItem={(data) => (
                  <List.Item
                    actions={[
                      <EditOutlined
                        style={{ color: "black" }}
                        onClick={() => {
                          setCurrentQuestion(data);
                          form.setFieldsValue({ question: data.question });
                          setVisible(true);
                        }}
                      />,
                    ]}
                  >
                    <ul>
                      <li> {data.question}</li>
                    </ul>
                  </List.Item>
                )}
              />
            )}
          </Col>
        </Row>
      </AdnCard>
      <Modal
        title={t("template.modals.updating")}
        open={visible}
        onOk={form.submit}
        onCancel={() => {
          setVisible(false);
        }}
        cancelText={t("template.buttons.back")}
        confirmLoading={submitLoading}
      >
        <Form
          form={form}
          name="form_in_modal"
          layout="vertical"
          onFinish={handleUpdate}
          initialValues={{ question: currentQuestion.question }}
        >
          <AdnInput
            placeholder={t("template.placeholders.question")}
            name="question"
            label={`${t("template.labels.question")} nº ${currentQuestion.id}`}
            rules={AdnValidationQuestion}
            maxLength={101}
          ></AdnInput>
        </Form>
      </Modal>
    </>
  );
}

export default TemplateListForm;
